import { TrendingDown, TrendingFlat, TrendingUp } from "@mui/icons-material";
import dayjs from "dayjs";
import { t } from "i18next";
import { get } from "lodash";
function SecondTable({ parameters, insightItems, children, slowTraining }) {
  const getColumns = () => {
    let param = get(parameters, "[0].computed_key_parameters", []);
    let columns = [
      `${t("date")} / ${t("eap:table:headers:track")} /${t("editTrainingForm:trainingType:label")} /${t("eap:table:headers:trackCondition")}`,
    ];
    if (param) {
      let arr = param.map(
        (e) =>
          get(
            e,
            "key_parameter_layout.insight_parameter.short_name_translated",
            get(e, "key_parameter_layout.insight_parameter.name_translated"),
          ) +
          `   (${get(e, "key_parameter_layout.insight_parameter.unit_translated")})`,
      );
      columns.push(...arr);
    }
    return columns;
  };

  const getExamData = (training) => {
    if (training) {
      let data = [];

      data.push(dayjs(get(training, "creation_date")).format("DD-MM-YYYY"));
      data.push(
        get(
          training,
          "track_name.display_name",
          get(training, "track_name_automatic.display_name", "-"),
        ),
      );
      data.push(
        get(
          training,
          "training_type.display_name",
          get(training, "training_type_automatic.display_name", "-"),
        ),
      );
      data.push(get(training, "track_condition.display_name", "-"));
      return data.join(" / ");
    } else {
      return "-";
    }
  };

  const getEvolutionIcon = (computedKeyParameter) => {
    if (
      computedKeyParameter["arrow_direction"] != null &&
      computedKeyParameter["arrow_color"] != 0
    ) {
      switch (computedKeyParameter["arrow_direction"]) {
        case "up":
          return <TrendingUp htmlColor={computedKeyParameter["arrow_color"]} />;
        case "down":
          return (
            <TrendingDown htmlColor={computedKeyParameter["arrow_color"]} />
          );
        case "stable":
          return (
            <TrendingFlat htmlColor={computedKeyParameter["arrow_color"]} />
          );
          default:
            return (
            <TrendingFlat htmlColor={computedKeyParameter["arrow_color"]} />
          );
      }
    }
  };

  const compactTextSize = slowTraining ? "text-[0.6rem]" : "text-[0.7rem]";
  const compactPadding = slowTraining ? "ps-0.5 pe-0.5 py-0.5" : "ps-1 pe-1 py-1";
  const compactMargin = slowTraining ? "mt-1.5" : "mt-3";
  const compactBarHeight = slowTraining ? "h-1" : "h-1.5";
  const compactBarMargin = slowTraining ? "mb-0.5" : "mb-1";
  const compactHighlightPadding = slowTraining
    ? "ps-0.5 pe-0.5 py-0.25"
    : "ps-1.5 pe-1.5 py-0.5";
  const compactCellPadding = slowTraining ? "ps-0.5 pe-0.5" : "ps-1 pe-1";

  return (
    <>
      {children}
      <div
        className={`${compactMargin} border-[2px] overflow-hidden border-redish rounded-md w-full relative overflow-x-auto`}
      >
        <table className="w-full">
          <tr className="bg-gradient start-0 top-0">
            {getColumns().map((col, i) => (
              <th
                id="header_police"
                key={i}
                className={`${i === 0 && "sticky start-[-1px] bg-redish"} text-white font-semibold text-center ${compactPadding} ${compactTextSize} ${i !== getColumns().length - 1 && "border-e-[1px] border-white"} `}
              >
                <p
                  className={
                    slowTraining
                      ? "ps-[0.25px] pe-[0.25px] leading-tight"
                      : "ps-[1px] pe-[1px] leading-tight"
                  }
                >
                  {col.replace("→", "\u2192")}
                </p>
              </th>
            ))}
          </tr>
          {parameters.map((param, i) => (
            <tr
              key={i}
              className={`${i !== parameters.length - 1 && "border-b-[1px] border-redish"}`}
            >
              <td
                className={`font-semibold text-center sticky start-[-1px] ${compactPadding} border-s-[1px] border-white ${compactTextSize}`}
              >
                <div
                  id="tr_police"
                  className={`w-full h-full  ${i % 2 === 0 ? "bg-white" : "stick_bg"} ${compactCellPadding}  `}
                >
                  {getExamData(param?.training)}
                </div>
              </td>
              {param?.computed_key_parameters?.map((paramKey, index) => (
                <td
                  id="tr_police"
                  key={index}
                  className={`text-center border-s-[1px] border-white ${compactTextSize} py-0`}
                >
                  {paramKey.color && (
                    <div
                      className={`w-[66%] ms-auto me-auto ${compactBarHeight} ${compactBarMargin} rounded-lg`}
                      style={{ background: paramKey.color }}
                    ></div>
                  )}
                  {/* {
                                        renderColor(paramKey) && <div className={`w-[50%] ms-auto me-auto h-1 mb-1 rounded-sm`} style={{ background: renderColor(paramKey) }}></div>
                                    } */}
                  <span
                    className={
                      paramKey.highlighted
                        ? `bg-gray-300 rounded-lg ${compactHighlightPadding} border border-black`
                        : null
                    }
                  >
                    {get(paramKey, "formatted_value", "-")}
                  </span>

                  {/* evolution */}
                  {get(
                    paramKey,
                    "key_parameter_layout.insight_parameter.category",
                  ) == "locomotion" &&
                    get(paramKey, "arrow_direction", null) !== null && (
                      <span> {getEvolutionIcon(paramKey)} </span>
                    )}
                </td>
              ))}
            </tr>
          ))}
        </table>
      </div>

      {/* Footer */}
      <div
        className="absolute  w-full"
        style={{
          bottom: "12px",
          fontSize: slowTraining ? "0.35rem" : "0.555rem",
          lineHeight: slowTraining ? "0.50rem" : "0.50rem",
        }}
      >
        <span className=" ">
          {" "}
          <TrendingUp htmlColor="grey" />{" "}
          {t("pdf:footer:arrowsExplanation")}{" "}
        </span>
      </div>
    </>
  );
}

export default SecondTable;